'use strict'

export class CertificatesStringConstructor {
  constructor ({ constructArray, certificateObject }) {
    this.constructArray = constructArray
    this.certificateObject = certificateObject
  }

  async construct () {
    let string = ''

    for (let constructObject of this.constructArray) {
      if (constructObject instanceof Function) {
        constructObject = await constructObject(this.certificateObject)
      }

      string += constructObject
    }

    return string
  }

  static async getIssuerCommonName (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.IssuerName, 'CN=')
  }

  static async getIssuerEmail (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.IssuerName, 'E=')
  }

  static async getIssuerCountryName (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.IssuerName, 'C=')
  }

  static async getIssuerLocality (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.IssuerName, 'L=')
  }

  static async getIssuerOrganization (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.IssuerName, 'O=')
  }

  static async getSubjectCommonName (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'CN=')
  }

  static async getSurname (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'SN=')
  }

  static async getGeneralName (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'G=')
  }

  static async getSubjectEmail (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'E=')
  }

  static async getSubjectCountryName (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'C=')
  }

  static async getSubjectStateOrProvinceName (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'S=')
  }

  static async getSubjectLocality (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'L=')
  }

  static async getSubjectOrganization (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'O=')
  }

  static async getSubjectOrganizationalUnit (certificateObject) {
    return await certificateObject.extractPure(await certificateObject.cert.SubjectName, 'OU=')
  }

  static async getValidFromDate (certificateObject) {
    return certificateObject.DateTimePutTogether(certificateObject.certFromDate)
  }

  static async getValidToDate (certificateObject) {
    return certificateObject.DateTimePutTogether(certificateObject.certTillDate)
  }

  static async getVersion (certificateObject) {
    return await certificateObject.cert.Version
  }

  static async getAlgorithmName (certificateObject) {
    return await certificateObject.GetFriendlyName()
  }
}
